export default __webpack_public_path__ + "static/media/shopping.6763f4d8.gif";